import React from 'react';
import { Navbar } from './Navbar';
import { Footer } from './Footer';

export const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-black text-white selection:bg-yellow-400 selection:text-black overflow-hidden">
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 overflow-hidden border-b-8 border-yellow-400">
        <div className="absolute inset-0 bg-halftone opacity-20 pointer-events-none"></div>
        <div className="container mx-auto px-6 relative z-10 text-center">
          <div className="inline-block bg-yellow-400 text-black px-4 py-1 transform -skew-x-12 mb-4 border border-black rotate-1 shadow-[4px_4px_0px_#fff]">
            <span className="font-anton text-sm tracking-widest uppercase transform skew-x-12 inline-block">LEGAL FRAMEWORK</span>
          </div>
          <h1 className="font-anton text-6xl md:text-8xl uppercase leading-none transform rotate-1 text-shadow-hard">
            TERMS OF <span className="text-red-600">SERVICE</span>
          </h1>
          <p className="font-marker text-xl md:text-2xl text-gray-400 mt-4 transform -rotate-1">The Rules of the Arena // Version 2.0</p>
        </div>
      </section>

      <div className="container mx-auto px-6 py-16 relative z-10">
        <div className="max-w-5xl mx-auto space-y-16">
          
          {/* Section 1: About */}
          <section className="relative group">
            <div className="absolute inset-0 bg-neutral-900 transform -skew-y-1 group-hover:skew-y-0 transition-transform"></div>
            <div className="relative p-8 border-2 border-gray-700">
              <h2 className="font-anton text-4xl text-yellow-400 mb-6 uppercase flex items-center gap-4">
                <span className="bg-yellow-400 text-black px-2 py-1 transform -rotate-3 text-2xl">01</span>
                About the Game
              </h2>
              <p className="font-sans text-gray-300 leading-relaxed text-lg">
                Cutthroat Dominoes Master is a strategic, competitive, and customizable All Fives dominoes experience. By accessing our services, you agree to abide by these terms and the rules of fair play.
              </p>
            </div>
          </section>

          {/* Section 2: Core Gameplay Rules */}
          <div className="grid md:grid-cols-2 gap-8">
            <section className="bg-white text-black p-8 border-4 border-black transform rotate-1 shadow-[10px_10px_0px_#ef4444]">
              <h2 className="font-anton text-3xl mb-6 uppercase">User Conduct</h2>
              <ul className="space-y-4 font-sans font-semibold">
                <li className="flex gap-2"><span className="text-red-600">✖</span> No cheating or exploitation</li>
                <li className="flex gap-2"><span className="text-red-600">✖</span> No abusive behavior in chats</li>
                <li className="flex gap-2"><span className="text-red-600">✖</span> No unauthorized modification of the app</li>
              </ul>
            </section>

            <section className="bg-black border-2 border-white p-8 transform -rotate-1 shadow-[10px_10px_0px_#eab308]">
              <h2 className="font-anton text-3xl text-white mb-6 uppercase">Ownership</h2>
              <p className="font-sans text-gray-400 leading-relaxed italic">
                All game assets, code, branding, and mechanics are the exclusive property of Cutthroat Dominoes Master. You are granted a non-exclusive license to play for personal use.
              </p>
            </section>
          </div>

          {/* Section 3: Legal Terms (The hard stuff) */}
          <section className="bg-neutral-900 border-2 border-gray-700 p-10 transform skew-y-1">
            <div className="transform -skew-y-1">
              <h2 className="font-anton text-4xl text-white mb-8 uppercase border-b-2 border-yellow-400 pb-2 inline-block">The Fine Print</h2>
              <div className="space-y-6 text-gray-400 font-sans text-sm leading-relaxed">
                <p>
                  <strong className="text-white uppercase">Disclaimer of Warranties:</strong> The game is provided "AS IS" and "AS AVAILABLE" without warranties of any kind, whether express or implied.
                </p>
                <p>
                  <strong className="text-white uppercase">Limitation of Liability:</strong> In no event shall Cutthroat Dominoes Master be liable for any damages arising out of the use or inability to use the services.
                </p>
                <p>
                  <strong className="text-white uppercase">Account Termination:</strong> We reserve the right to suspend or terminate accounts that violate these terms or engage in fraudulent activities without prior notice.
                </p>
              </div>
            </div>
          </section>

          {/* Section 4: Contact */}
          <section className="text-center py-12">
            <p className="font-marker text-2xl text-gray-400 mb-6">Got questions? We've got answers.</p>
            <div className="inline-block bg-yellow-400 text-black px-10 py-4 font-anton text-2xl transform -skew-x-12 border-2 border-black hover:bg-white transition-colors cursor-pointer">
              SUPPORT@CUTTHROATDOMINOES.COM
            </div>
          </section>

        </div>
      </div>

      <Footer />
    </div>
  );
};